module.exports = __webpack_public_path__ + "img/pic_elf_03.3540938b.png";